import React from 'react';
import { TbBrandVite } from 'react-icons/tb';
import { getLcn } from '~/utils/labeled-classnames';

export default function ViteRefreshCert() {
  const lcn = getLcn({
    viteRefreshCert: 'fixed bottom-4 left-4 z-50 opacity-60 hover:opacity-100 cursor-pointer inline-block p-2 bg-red-600/20 rounded-full shadow-lg print:hidden',
  });

  return (
    <a href='https://localhost:3036/vite-dev/'
      className={lcn.viteRefreshCert}
      title='re-certify locahost'>
      <TbBrandVite color='red' size={30} />
    </a>
  );
}; 